const scrollTo = {
  scrollBtn: document.getElementById('jsScrollBtn') as HTMLElement,
  scrollSection: document.getElementById('jsScrollSection') as HTMLElement,

  offset: 150, 

  init() {
    if (!this.scrollBtn || !this.scrollSection) return;

    this.setScrollPos();
  },

  setScrollPos() {
    this.scrollBtn.addEventListener('click', () => {
      const sectionTop =
        this.scrollSection.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: sectionTop - this.offset,
        behavior: 'smooth',
      });
    });
  },
};

export default scrollTo;